import React from "react";

const ROWS = 4;

export default function SubstitutionsTableSkeleton() {
  return (
    <div className="vs-skeleton" role="status" aria-label="Загрузка назначений">
      <div className="skeleton vs-skeleton__title" />
      {Array.from({ length: ROWS }, (_, i) => (
        <div key={i} className="vs-skeleton__row">
          <div className="skeleton vs-skeleton__c1" />
          <div className="skeleton vs-skeleton__c2" />
          <div className="skeleton vs-skeleton__c3" />
        </div>
      ))}
    </div>
  );
}
